import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './SearchableDropdown.css';

const Searchable = ({
    options,
    value,
    onChange,
    placeholder,
    disabled = false,
    loading = false,
    className = '',
    getOptionLabel = (opt) => opt.label || opt.description || '',
    getOptionValue = (opt) => opt.value || opt.id
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    // Filtrar opciones basado en el término de búsqueda
    const filteredOptions = options.filter(option =>
        getOptionLabel(option).toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Cerrar dropdown cuando se hace clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (option) => {
        onChange(getOptionValue(option));
        setIsOpen(false);
        setSearchTerm('');
    };

    const selectedOption = options.find(option => getOptionValue(option) === value);

    return (
        <div className={`searchable-dropdown ${className}`} ref={dropdownRef}>
            <div
                className={`dropdown-header ${disabled ? 'disabled' : ''} ${loading ? 'loading' : ''}`}
                onClick={() => !disabled && !loading && setIsOpen(!isOpen)}
            >
                <span className="dropdown-value">
                    {selectedOption ? getOptionLabel(selectedOption) : placeholder}
                </span>
                <span className="dropdown-arrow">▼</span>
            </div>

            {isOpen && (
                <div className="dropdown-content">
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="search-input"
                            autoFocus
                        />
                    </div>

                    <div className="options-container">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map(option => (
                                <div
                                    key={getOptionValue(option)}
                                    className={`dropdown-option ${getOptionValue(option) === value ? 'selected' : ''}`}
                                    onClick={() => handleSelect(option)}
                                >
                                    {getOptionLabel(option)}
                                </div>
                            ))
                        ) : (
                            <div className="no-results">No se encontraron resultados</div>
                        )}
                    </div>
                </div>
            )}

            {loading && <div className="loading-indicator">Cargando...</div>}
        </div>
    );
};


Searchable.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
};

export default Searchable; 